import { render, staticRenderFns } from "./profit_details.vue?vue&type=template&id=c950b4f0&scoped=true"
import script from "./profit_details.vue?vue&type=script&lang=js"
export * from "./profit_details.vue?vue&type=script&lang=js"
import style0 from "./profit_details.vue?vue&type=style&index=0&id=c950b4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c950b4f0",
  null
  
)

export default component.exports